/**
 * Provides the current Obelisk workspace ID to the Remotion editor tree.
 *
 * Used for:
 * - Scoping localStorage persistence per workspace
 * - Fetching workspace media for the "Import from Library" modal
 * - Associating rendered outputs with the workspace
 */

import {createContext, useContext} from 'react';

const WorkspaceIdContext = createContext<string | null>(null);

export function WorkspaceIdProvider({
	workspaceId,
	children,
}: {
	workspaceId: string;
	children: React.ReactNode;
}) {
	return (
		<WorkspaceIdContext.Provider value={workspaceId}>
			{children}
		</WorkspaceIdContext.Provider>
	);
}

/**
 * Returns the current workspace ID.
 * Must be used inside a <WorkspaceIdProvider>.
 */
export function useWorkspaceId(): string {
	const id = useContext(WorkspaceIdContext);
	if (!id) {
		throw new Error(
			'useWorkspaceId must be used within a <WorkspaceIdProvider>',
		);
	}
	return id;
}

